import {cn} from "@/lib/utils.ts";

// "Official DUPR Partner" mark for the top-right of a marketing hero (below the nav bar). Sits in the
// gap between the nav and hero content — smaller/tighter on mobile, roomier on lg+.
// Drop it inside a hero's `relative` <section>.
export default function DuprPartnerBadge({className}: {className?: string}) {
    return (
        <div className={cn(
            "pointer-events-none absolute z-30 flex items-center gap-1.5 lg:gap-2 top-[64px] right-7 sm:top-[80px] sm:right-8 lg:top-[100px] lg:right-14",
            className,
        )}>
            <span className="font-inter text-[9px] lg:text-[10px] font-semibold uppercase tracking-[0.12em] lg:tracking-[0.14em] text-white/55 whitespace-nowrap">Official DUPR Partner</span>
            <img src="/DUPR-White.png" alt="DUPR — Official Partner" className="h-5 lg:h-6 xl:h-7 w-auto opacity-95" />
        </div>
    );
}
